/**
 * These Events are supposed to be dispatched within the system
 * and should be listened by different parts of the app.
 */
export const EVENTS = {
    UNAUTHORIZED_ACCESS: 'unauthorized_access',
    TRANSACTION_PROCESSED: 'transaction_processed',
    TRANSACTION_DECLINED: 'transaction_declined',
    BET_PROCESSED: 'bet_processed',
    BTC_EXCHANGE_RATE: 'btc.exchange_rate',
    PRODUCT_REQUESTED: 'product_requested',
    BITCOIN_RATE_TRANSACTION_EXPIRED: 'bitcoin_rate_transaction_expired',
    KYC_FILE_UPLOADED: 'kyc_file_uploaded',
    KYC_FILE_DELETED: 'kyc_file_deleted',
    LANGUAGE_UPDATED: 'language_updated',
    AVATAR_UPDATED: 'avatar_updated',
    GAUTH_RESET: 'gauth_reset'
}

export default EVENTS;



// WEBPACK FOOTER //
// ./client/app/shared/events.js